import type { Styles } from 'common/types';

export const styles: Styles = {
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
    width: '100%',
  },
  list: {
    display: 'flex',
    flexDirection: 'row',
    gap: 2,
    overflowX: 'auto',
    pb: 1,
  },
  cardWrapperDragging: {
    opacity: 0.85,
    boxShadow: '0px 8px 24px rgba(0, 0, 0, 0.12)',
  },
  cardWrapper: {
    flex: '0 0 320px',
  },
  emptyState: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    py: 4,
    gap: 1,
    color: 'text.disabled',
    borderRadius: 2,
    border: '1px dashed',
    borderColor: 'divider',
  },
  dialogTitle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
};
